<template>
  <div ref="editor" />
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false,
      default: null
    },
    language: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      editor: null,
    }
  },

  beforeDestroy() {
    this.editor.destroy();
  },

  mounted() {
    this.editor = window.ace.edit(this.$refs.editor, {
      mode: `ace/mode/${this.language}`,
      theme: 'ace/theme/dracula',
      showPrintMargin: false,
      selectionStyle: 'text',
      useWorker: true
    });

    this.editor.session.on('change', () => {
      const value = this.editor.getValue();
      this.$emit('input', value);
    });

    if (this.value) {
      this.editor.setValue(this.value, -1);
    }
  },
}
</script>